(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["finer-engagement-campaign"] && !Shopify.designMode) return;
  try {
    
function initialiseFinerLanding(root) {
  if (root.dataset.initialised) return;
  root.dataset.initialised = 'true';
  root.querySelectorAll('.faq details').forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.open) root.querySelectorAll('.faq details').forEach(other => { if (other !== item) other.open = false; });
    });
  });
  let deadline = Date.parse(root.dataset.deadline);
  if (!Number.isFinite(deadline) && root.dataset.themeRole !== 'main') {
    const key = 'finer-shopify-draft-countdown';
    let saved;
    try { saved = Number(sessionStorage.getItem(key)); } catch {}
    deadline = saved > 0 ? saved : Date.now() + 237037000;
    try { sessionStorage.setItem(key, String(deadline)); } catch {}
  }
  const timers = root.querySelectorAll('.countdown');
  const update = () => {
    if (!Number.isFinite(deadline)) { timers.forEach(timer => { timer.hidden = true; }); return false; }
    const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
    const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
    timers.forEach(timer => Object.entries(values).forEach(([unit, value]) => { timer.querySelector('[data-time="' + unit + '"]').textContent = String(value).padStart(2, '0'); }));
    return seconds > 0;
  };
  if (update()) { const tick = setInterval(() => { if (!root.isConnected || !update()) clearInterval(tick); }, 1000); }
  const frames = root.querySelectorAll('.video-frame');
  const load = frame => {
    const video = frame.querySelector('video');
    if (!video.dataset.loaded) { video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; }); video.load(); video.dataset.loaded = 'true'; }
    return video;
  };
  frames.forEach(frame => {
    const button = frame.querySelector('.video-start');
    if (!button) return;
    const video = frame.querySelector('video');
    button.addEventListener('click', () => { load(frame).play().then(() => { button.hidden = true; }).catch(() => { button.hidden = false; }); });
    video.addEventListener('playing', () => { button.hidden = true; });
  });
  const autoFrames = Array.from(frames).filter(frame => frame.dataset.autoplay === 'true');
  const play = frame => {
    const video = load(frame);
    video.muted = true;
    video.controls = false;
    video.play().catch(() => {});
  };
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      entry.target.dataset.inView = String(entry.isIntersecting);
      if (entry.isIntersecting && !document.hidden) play(entry.target);
      else entry.target.querySelector('video').pause();
    }), { rootMargin: '150px 0px', threshold: 0.01 });
    autoFrames.forEach(frame => observer.observe(frame));
  } else {
    autoFrames.forEach(frame => { frame.dataset.inView = 'true'; play(frame); });
  }
  document.addEventListener('visibilitychange', () => autoFrames.forEach(frame => {
    if (document.hidden) frame.querySelector('video').pause();
    else if (frame.dataset.inView === 'true') play(frame);
  }));
  autoFrames.forEach(frame => frame.addEventListener('click', () => play(frame)));
  const returnInput = root.querySelector('[name="return_to"]');
  const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
  if (returnInput && previewTheme) returnInput.value += '&preview_theme_id=' + encodeURIComponent(previewTheme);
}
document.querySelectorAll('[data-finer-lp]').forEach(initialiseFinerLanding);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-finer-lp]').forEach(initialiseFinerLanding));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finer-gift-registration"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const controlSelector = "input:not([type='hidden']):not([type='submit']):not([type='button']):not([type='radio']):not([type='checkbox']), select, textarea";

    const lowestCommonAncestor = (nodes) => {
      const validNodes = nodes.filter(Boolean);
      if (!validNodes.length) return null;

      let ancestor = validNodes[0];
      while (ancestor) {
        if (validNodes.every((node) => ancestor.contains(node))) return ancestor;
        ancestor = ancestor.parentElement;
      }
      return null;
    };

    const directChildOf = (node, parent) => {
      if (!node || !parent || !parent.contains(node)) return null;
      let current = node;
      while (current.parentElement && current.parentElement !== parent) current = current.parentElement;
      return current.parentElement === parent ? current : null;
    };

    const getLabel = (form, input) => {
      if (input.id) {
        const externalLabel = Array.from(form.querySelectorAll('label[for]')).find((label) => label.htmlFor === input.id);
        if (externalLabel) return externalLabel;
      }
      return input.closest('label');
    };

    const getFieldWrapper = (control, form) => {
      let node = control.parentElement;
      let candidate = node;

      while (node && node.parentElement && node.parentElement !== form) {
        if (node.querySelectorAll(controlSelector).length > 1) break;
        candidate = node;
        node = node.parentElement;
      }
      return candidate || control;
    };

    const getChoiceGroup = (form) => {
      const choices = Array.from(form.querySelectorAll("input[type='radio'], input[type='checkbox']"));
      const grouped = new Map();

      choices.forEach((input) => {
        const key = input.closest('fieldset') || input.name || input;
        const group = grouped.get(key) || [];
        group.push(input);
        grouped.set(key, group);
      });

      const knownOptions = ['wedding ring', 'engagement ring', 'bridal jewellery', 'bridal jewelry', 'just exploring'];
      const candidates = Array.from(grouped.values()).map((group) => {
        const text = group.map((input) => {
          const label = getLabel(form, input);
          return label ? label.textContent.toLowerCase() : '';
        }).join(' ');
        const knownScore = knownOptions.filter((option) => text.includes(option)).length;
        return { group, score: knownScore * 10 + group.length };
      }).filter((item) => item.group.length > 1 || item.score >= 10);

      candidates.sort((a, b) => b.score - a.score);
      return candidates.length ? candidates[0].group : [];
    };

    const enhanceForm = (section) => {
      const root = section.querySelector("[data-form-root='true']");
      const form = root && root.querySelector('form');
      if (!form) return;

      const controls = Array.from(form.querySelectorAll(controlSelector));
      const fieldWrappers = [];

      controls.forEach((control, index) => {
        control.classList.add('finer-gift-input');

        const descriptor = [control.type, control.name, control.id, control.placeholder, control.getAttribute('autocomplete')]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        const label = getLabel(form, control);
        const labelText = label ? label.textContent.trim() : '';

        if (control.tagName === 'INPUT' && (control.type === 'email' || descriptor.includes('email'))) {
          control.classList.add('finer-gift-input--email');
        } else if (control.tagName === 'INPUT' && (control.type === 'tel' || descriptor.includes('phone') || descriptor.includes('mobile'))) {
          control.classList.add('finer-gift-input--phone');
        } else if (control.tagName === 'INPUT' && (control.type === 'date' || descriptor.includes('date'))) {
          control.classList.add('finer-gift-input--date');
        } else if (control.tagName === 'INPUT' && (descriptor.includes('name') || index === 0)) {
          control.classList.add('finer-gift-input--name');
        }

        if (!control.placeholder && labelText && control.type !== 'date') control.placeholder = labelText;

        if (label) {
          if (label.contains(control)) label.classList.add('finer-gift-wrapping-label');
          else label.classList.add('finer-gift-sr-label');
        }

        const wrapper = getFieldWrapper(control, form);
        fieldWrappers.push(wrapper);

        if (control.classList.contains('finer-gift-input--date')) {
          wrapper.classList.add('finer-gift-date-item');
          wrapper.dataset.finerLabel = labelText || 'Wedding Date (optional)';

          const updateDateState = () => wrapper.classList.toggle('has-value', Boolean(control.value));
          updateDateState();
          if (!control.dataset.finerDateBound) {
            control.addEventListener('input', updateDateState);
            control.addEventListener('change', updateDateState);
            control.dataset.finerDateBound = 'true';
          }
        }
      });

      const choices = getChoiceGroup(form);
      let interestGroup = null;

      if (choices.length) {
        interestGroup = choices[0].closest('fieldset') || lowestCommonAncestor(choices.map((input) => getLabel(form, input) || input));
        if (interestGroup) {
          interestGroup.classList.add('finer-gift-interest-group');
          const legend = interestGroup.querySelector('legend');
          if (legend) legend.classList.add('finer-gift-interest-legend');
          else interestGroup.dataset.finerHeading = section.dataset.interestHeading || '';
        }

        choices.forEach((input) => {
          input.classList.add('finer-gift-choice-input');
          const label = getLabel(form, input);
          if (label) label.classList.add('finer-gift-choice-label');
        });
      }

      const submit = form.querySelector("button[type='submit'], input[type='submit']");
      if (submit) submit.classList.add('finer-gift-submit');

      const grid = lowestCommonAncestor([...fieldWrappers, interestGroup, submit].filter(Boolean));
      if (!grid || grid === root || !form.contains(grid)) return;

      grid.classList.add('finer-gift-fields-grid');
      fieldWrappers.forEach((wrapper) => {
        const item = directChildOf(wrapper, grid);
        if (item) item.classList.add('finer-gift-field-item');
      });

      if (interestGroup) {
        const item = directChildOf(interestGroup, grid);
        if (item) item.classList.add('finer-gift-interest-item');
      }

      if (submit) {
        const item = directChildOf(submit, grid);
        if (item) item.classList.add('finer-gift-submit-item');
      }
    };

    document.querySelectorAll('.finer-gift-registration').forEach((section) => {
      let scheduled = false;
      const scheduleEnhancement = () => {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(() => {
          scheduled = false;
          enhanceForm(section);
        });
      };

      scheduleEnhancement();
      const observer = new MutationObserver(scheduleEnhancement);
      observer.observe(section, { childList: true, subtree: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  if (window.innerWidth >= 990) {
    document.querySelectorAll('.header__inline-menu header-menu details').forEach(details => {
      let closeTimer;

      details.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        details.open = true;
      });

      details.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => {
          details.open = false;
        }, 100);
      });

      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (e) => {
          const link = summary.querySelector('a.header__menu-item-link');
          if (link) {
            e.preventDefault();
            window.location.href = link.href;
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
